import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Special_Fee_Report.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

function statusVariant(status) {
  const s = (status || "").toLowerCase();
  if (s === "paid" || s === "active" || s === "approved" || s === "success") return "yc-status--success";
  if (s === "pending" || s === "warning") return "yc-status--warning";
  if (s === "failed" || s === "rejected" || s === "danger") return "yc-status--danger";
  return "yc-status--neutral";
}

function Special_Fee_Report() {
  const [feeData, setFeeData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");

  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key: localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        id: selectedCategory || 36,
      };

      const response = await simplePostCall(ApiConfig.specialfeereports, JSON.stringify(payload));

      if (response && response.result) {
        setFeeData(response.data || []);
        if (response.category && categories.length === 0) {
          setCategories(response.category);
        }
      }
    } catch (error) {
      console.error("Error fetching special fee report:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedCategory, categories.length]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchInitialData();
  };

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Special Fee Report</h4>
        <button className="btn btn-primary">Export</button>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <select
            className="form-select"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="">Select Fee Category</option>
            {categories.map((cat) => (
              <option key={cat.fee_category_id} value={cat.fee_category_id}>
                {cat.fee_category_name}
              </option>
            ))}
          </select>
          <button
            className="btn btn-primary"
            onClick={handleSearch}
            disabled={loading}
          >
            {loading ? "Searching..." : "Search"}
          </button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-7">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Invoice ID</div>
            <div className="yc-list-cell">Student</div>
            <div className="yc-list-cell">Academic Year</div>
            <div className="yc-list-cell">Demand Date</div>
            <div className="yc-list-cell">Amount Total</div>
            <div className="yc-list-cell">Status</div>
          </div>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : feeData.length > 0 ? (
          <div className="yc-list-row-list">
            {feeData.map((item, index) => (
              <div key={item.invoice_id} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-7">
                  <div className="yc-list-cell">{index + 1}</div>
                  <div className="yc-list-cell">#{item.invoice_id}</div>
                  <div className="yc-list-cell">{item.student_name}</div>
                  <div className="yc-list-cell">{item.academic_year}</div>
                  <div className="yc-list-cell">{item.demand_date}</div>
                  <div className="yc-list-cell">{formatNumber(item.amount_total)}</div>
                  <div className="yc-list-cell">
                    <span className={`yc-status ${statusVariant(item.status)}`}>
                      {(item.status || "").toUpperCase()}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="yc-empty-state">No results found.</div>
        )}
      </div>
    </div>
  );
}

export default Special_Fee_Report;
